import { FC } from "react";
import { classNames } from "@/utils/classNames";

const widthClassNames = {
  "1/3": "w-1/3",
  "1/2": "w-1/2",
  "2/3": "w-2/3",
  full: "w-full",
} as const;

export type SkeletonProps = { width?: keyof typeof widthClassNames };

export const Skeleton: FC<SkeletonProps> = ({ width = "full" }) => (
  <div aria-hidden className={"flex h-6 items-center"}>
    <div className={classNames("shimmer-block", "rounded-sm", "h-4", widthClassNames[width])} />
  </div>
);
